<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-1">Burgundy: Twisted Roots</p>
<p class="book-subtitle" xml:lang="en-GB"><span class="char-style-override">A Vengeance in the <br class="calibre1"/>Vineyard Mystery</span></p>
<p class="book-author" xml:lang="en-GB">Janet Hubbard</p>
<p class="book-publisher" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="body-center"><span class="calibre2"><img alt="29375.png" class="frame" src="OEBPS/image/29375.png"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Burgundy_Twisted_Roots.vue?fecd5f5e